import * as yup from 'yup';
import { validationErrors } from './validationErrors';

const urlRegEx =
  /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi;

  // Http regex
  const httpRegx= /http(s)?:\/\/.[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi;

export const yupMaxStr = yup
  .string()
  .max(255, 'This field must be at most 255 characters');
export const yupMaxLongStr = yup
  .string()
  .max(510, 'This field must be at most 510 characters');

const requiredDefaultStringRule = yupMaxStr.required(
  validationErrors.REQUIRED_FIELD,
);
const USER_FIRST_NAME = requiredDefaultStringRule;
const USER_LAST_NAME = requiredDefaultStringRule;
const USER_TITLE = requiredDefaultStringRule;
const USER_COMPANY_NAME = requiredDefaultStringRule;
const PHONE_NUMBER = yup
  .number()
  .test(
    'Is positive?',
    'Please enter a valid mobile number',
    (value) => value !== undefined && value !== null && value > 0,
  );

export const EMAIL = yup.string().email('Must be valid email');

export const getPasswordRule = (msg: string): any =>
  yup
    .string()
    .matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/, msg);

export const PASSWORD = getPasswordRule(validationErrors.PASSWORD_VALID);

export const URL = yup.string().matches(urlRegEx, 'Must be link');

// HTTP URL
export const HTTP_URL = yup.string().matches(httpRegx, 'Must be link');

export const LINKEDIN = yup
  .string()
  .matches(
    /http(s)?:\/\/.*linkedin.com\/in\/.+/,
    'Must be valid LinkedIn profile url',
  );

export const DEFAULT_MAX_LENGTH = yup
  .string()
  .max(255, 'Must be less than 255 characters');

export const ARRAY_OF_STRINGS = yup
  .array()
  .of(yup.string().required(validationErrors.REQUIRED_FIELD));

export const ARRAY_OF_URLS = yup
  .array()
  .of(URL.required('This field is required'));

// HTTP ARRAY
export const ARRAY_OF_HTTPURLS = yup
  .array()
  .of(HTTP_URL.required('This field is required'));


export const ARRAY_OF_NUMBERS = yup.array().of(yup.number());
export const ARRAY_OF_NUMBERS_REQUIRED = yup
  .array()
  .of(yup.number())
  .min(1, validationErrors.REQUIRED_CHECKBOXES)
  .required(validationErrors.REQUIRED_CHECKBOXES);

const NEWS_TITLE = requiredDefaultStringRule;
const NEWS_TEXT = yup
  .string()
  // .max(500, 'This field must be at most 500 characters')
  .required(validationErrors.REQUIRED_FIELD);
const NEWS_LINK = yup
  .string()
  .matches(
    /(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%.#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%.#?&//=]*)/,
    'Enter valid url',
  )
  .required(validationErrors.REQUIRED_FIELD);
const RATING = yup
  .number()
  .test(
    'Is positive?',
    'Please choose a valid rating number',
    (value) => value !== undefined && value !== null && value > 0,
  );
const LINK = yup
  .string()
  .matches(
    /(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%.#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%.#?&//=]*)/,
    'Enter valid url',
  )
  .required(validationErrors.REQUIRED_FIELD);

export const validationRules = {
  yupMaxStr,
  yupMaxLongStr,
  EMAIL,
  URL,
  PASSWORD,
  LINKEDIN,
  DEFAULT_MAX_LENGTH,
  ARRAY_OF_URLS,
  ARRAY_OF_HTTPURLS,
  ARRAY_OF_STRINGS,
  ARRAY_OF_NUMBERS,
  ARRAY_OF_NUMBERS_REQUIRED,
  USER_FIRST_NAME,
  USER_LAST_NAME,
  USER_TITLE,
  USER_COMPANY_NAME,
  PHONE_NUMBER,
  getPasswordRule,
  requiredDefaultStringRule,
  NEWS_TITLE,
  NEWS_TEXT,
  NEWS_LINK,
  RATING,LINK
};
